import React from 'react'
import { Tooltip } from 'react-tooltip'
import { ProductImpregnation } from '../src/model/fragments'
import SvgAntiSlip from './icons/SvgAntiSlip'
import SvgEdge from './icons/SvgEdge'
import SvgEuNorms from './icons/SvgEuNorms'
import SvgFrostResistant from './icons/SvgFrostResistant'
import SvgImpregnationIn from './icons/SvgImpregnationIn'
import SvgImpregnationN from './icons/SvgImpregnationN'
import SvgImpregnationPct from './icons/SvgImpregnationPct'
import SvgImpregnationTop from './icons/SvgImpregnationTop'
import SvgRideableByCar from './icons/SvgRideableByCar'
import SvgRideableByTruck from './icons/SvgRideableByTruck'
import SvgWalkable from './icons/SvgWalkable'

export interface AttributesProps {
	walkable?: boolean
	rideableByCar?: boolean
	rideableByTruck?: boolean
	frostResistant?: boolean
	antiSlip?: boolean
	euNorms?: boolean
	withoutChamfer?: boolean
	visibleEdge?: boolean
	customMade?: boolean
	impregnation?: ProductImpregnation
}

export const Attributes: React.FunctionComponent<AttributesProps> = ({
	walkable,
	rideableByCar,
	rideableByTruck,
	frostResistant,
	antiSlip,
	euNorms,
	withoutChamfer,
	visibleEdge,
	customMade,
	impregnation,
}) => {
	return (
		<div className="attributes">
			{[
				{ isActive: walkable, icon: <SvgWalkable />, title: 'Plocha pochozí' },
				{
					isActive: rideableByCar,
					icon: <SvgRideableByCar />,
					title: 'Plocha pojízdná osobními automobily',
				},
				{
					isActive: rideableByTruck,
					icon: <SvgRideableByTruck />,
					title: 'Plocha pojízdná nákladními automobily',
				},
				{
					isActive: frostResistant,
					icon: <SvgFrostResistant />,
					title: 'Odolnost vůči mrazu',
				},
				{
					isActive: antiSlip,
					icon: <SvgAntiSlip />,
					title: 'Zvýšená protiskluzná charakteristika',
				},
				{
					isActive: euNorms,
					icon: <SvgEuNorms />,
					title: 'Výrobky podléhají příslušným evropským normám',
				},
				{
					isActive: visibleEdge,
					icon: <SvgEdge />,
					title: 'Pohledové hrany',
				},
				/*{ isActive: withoutChamfer, icon: <>@TODO</>, title: 'Bez fazety' },
				{ isActive: customMade, icon: <>@TODO</>, title: 'Zakázková výroba' },*/
				{
					isActive: impregnation === ProductImpregnation.IN,
					icon: <SvgImpregnationIn />,
					title: `Ochranný systém Protect System IN`,
				},
				{
					isActive: impregnation === ProductImpregnation.N,
					icon: <SvgImpregnationN />,
					title: `Ochranný systém Protect System N`,
				},
				{
					isActive: impregnation === ProductImpregnation.PCT,
					icon: <SvgImpregnationPct />,
					title: `Impregnace Perfect Clean TOP (PCT)`,
				},
				{
					isActive: impregnation === ProductImpregnation.TOP,
					icon: <SvgImpregnationTop />,
					title: `Protect System TOP`,
				},
			].map(
				(attribute, i) =>
					attribute.isActive && (
						<div className="attributes-item" key={i}>
							<a className="attributes-item-in" data-tooltip-content={attribute.title}>
								{attribute.icon}
							</a>
						</div>
					),
			)}
			<Tooltip anchorSelect=".attributes-item-in" />
		</div>
	)
}
